import React from 'react'
import { Grid, Stack, Link } from '@mui/material'
import Logo from 'components/assets/Logo'
import Button from 'components/landing-page/Button'
import MatButton from '@mui/material/Button'
import { useNavigate, Link as RouterLink } from 'react-router-dom'
import { trackEvent } from 'utils/tracking'
import { CHURN_ZERO_EVENTS as cz } from 'utils/constants'

const styles = {
  '&.MuiButton-root': {
    border: '1px white solid',
  },
  '&.MuiButton-text': {
    color: 'white',
  },
  '&.MuiButton-contained': {
    color: 'white',
  },
  '&.MuiButton-outlined': {
    color: 'white',
  },
}

const Header = () => {
  const navigate = useNavigate()
  const loginWithRedirectAndTrackCZ = () => {
    trackEvent(cz.LOG_IN)
    navigate('/app/purchases')
  }

  return (
    <Grid container alignItems="center" justifyContent="space-between" pt={2} pb={6}>
      <Grid item xs={5} md={2}>
        <Link color="inherit" component={RouterLink} to="/">
          <Logo />
        </Link>
      </Grid>

      <Grid item>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <Link color="inherit" component={RouterLink} to="about-us">
            <MatButton sx={styles} size="large" variant="outlined">
              About Us
            </MatButton>
          </Link>
          <Link color="inherit" rel="noopener noreferrer" target="_blank" href="https://medium.com/greenspark-software">
            <MatButton sx={styles} size="large" variant="outlined">
              Blog
            </MatButton>
          </Link>
          <Link color="inherit" component={RouterLink} to="careers">
            <MatButton sx={styles} size="large" variant="outlined">
              Careers
            </MatButton>
          </Link>
          <Link href="mailto:hello@greensparksoftware.com" underline="none">
            <Button size="large">Contact Us</Button>
          </Link>
          <Button size="large" onClick={() => loginWithRedirectAndTrackCZ()}>
            Login
          </Button>
        </Stack>
      </Grid>
    </Grid>
  )
}

Header.propTypes = {}

Header.defaultProps = {}

export default Header
